'use strict';

module.exports = [

    '$sce', 

    function (sce) {
        return function (input) {
            
            return sce.trustAsHtml(input);
        };
    }
];



// WEBPACK FOOTER //
// ./src/busqueda/filtros/html-seguro.filter.js